import React from 'react';

const InfantCaption = () => (
  <div className="infantCaption">
    ※座席の利用はできません。同伴の大人の方の膝の上にお座りください。
  </div>
);

export default InfantCaption;
